import JSZip from 'jszip';

export type ZipFile = {
  name: string;
  contents: string;
};

export async function createZipBlob(files: ZipFile[]): Promise<Blob> {
  const zip = new JSZip();
  files.forEach((file) => zip.file(file.name, file.contents));
  return zip.generateAsync({
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: { level: 6 },
  });
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
